import { map, mergeDeepRight } from 'ramda'

const pages =
  [
    {
      path: 'authorization/index',
      redirect: '/h5/video-clip/authorization/index'
    },
    {
      path: 'authorization/login',
      component: () => import(/* webpackChunkName: "h5-authorization/login" */ '@/views/h5/authorization/login'),
      meta: {
        requireLogin: false,
        notShowDialog: true
      }
    },
    {
      path: 'video-clip',
      redirect: { name: 'h5-video-clip-home' },
      component: () => import(/* webpackChunkName: "h5/video-clip/index" */ '@/views/h5/video-clip/index'),
      children:
        [
          {
            path: 'authorization/index',
            name: 'h5-authorization-index',
            component: () => import(/* webpackChunkName: "h5-authorization/index" */ '@/views/h5/authorization')
          },
          {
            path: 'content-index',
            name: 'h5-video-clip-index',
            component: () =>
              import(/* webpackChunkName: "h5/video-clip/content-index" */ '@/views/h5/video-clip/content-index')
          },
          {
            path: 'download-guide-index',
            name: 'h5-video-download-guide-index',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/download-guide-index" */ '@/views/h5/video-clip/download-guide.vue'
              )
          },
          {
            path: 'live-list',
            name: 'h5-video-clip-live-list',
            component: () =>
              import(/* webpackChunkName: "h5/video-clip/live-list" */ '@/views/h5/video-clip/live-list.vue')
          },
          {
            path: 'download-manage',
            name: 'h5-video-clip-download-manage',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/download-manage" */ '@/views/h5/video-clip/download-manage.vue'
              ),
            meta: {
              scrollToTop: true
            }
          },
          {
            path: 'material-download',
            name: 'h5-video-clip-material-download',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/material-download" */ '@/views/h5/video-clip/material-download.vue'
              ),
            meta: {
              scrollToTop: true
            }
          },
          {
            path: 'home',
            name: 'h5-video-clip-home',
            component: () => import(/* webpackChunkName: "h5/video-clip/home" */ '@/views/h5/video-clip/home.vue'),
            meta: {
              requireLogin: false,
              scrollToTop: true
            }
          },
          {
            path: 'bind/:promoteCode',
            name: 'h5-video-clip-bind',
            component: () => import(/* webpackChunkName: "h5/video-clip/bind" */ '@/views/h5/video-clip/bind.vue'),
            meta: {
              requireLogin: true,
              scrollToTop: true
            }
          },
          {
            path: 'playlet',
            name: 'h5-playlet-home',
            component: () =>
              import(/* webpackChunkName: "h5/video-clip/playlet" */ '@/views/h5/video-clip/playlet.vue'),
            meta: {
              requireLogin: false,
              scrollToTop: true
            }
          },
          {
            path: 'ready',
            redirect: { name: 'h5-video-clip-home' },
            name: 'h5-video-clip-ready',
            component: () =>
              import(/* webpackChunkName: "h5/video-clip/ready" */ '@/views/h5/video-clip/first-ready.vue'),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'choose-author',
            name: 'h5-video-clip-choose-author',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/choose-author" */ '@/views/h5/video-clip/choose-author.vue'
              ),
            meta: {
              keepAlive: false
            }
          },
          {
            path: 'fill-info',
            name: 'h5-video-clip-fill-info',
            component: () =>
              import(/* webpackChunkName: "h5/video-clip/fill-info" */ '@/views/h5/video-clip/fill-info.vue')
          },
          {
            path: 'cooperation-step',
            name: 'h5-video-clip-cooperation-step',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/cooperation-step" */ '@/views/h5/video-clip/cooperation-step.vue'
              )
          },
          {
            path: 'examine-result',
            name: 'h5-video-clip-examine-result',
            meta: {
              scrollToTop: true
            },
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/examine-result" */ '@/views/h5/video-clip/examine-result.vue'
              )
          },
          {
            path: 'appointment-result',
            name: 'h5-video-clip-appointment-result',
            meta: {
              scrollToTop: true
            },
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/appointment-result" */ '@/views/h5/video-clip/appointment-result.vue'
              )
          },
          // 签名
          {
            path: 'signature',
            name: 'signature',
            component: () =>
              import(/* webpackChunkName: "h5/video-clip/signature" */ '@/views/h5/video-clip/signature/index')
          },
          {
            path: 'help',
            name: 'h5-video-clip-help',
            component: () =>
              import(/* webpackChunkName: "h5/video-clip/help-center" */ '@/views/h5/video-clip/help-center.vue'),
            meta: {
              requireLogin: false
            }
          },
          // 查看协议
          {
            path: 'slicing-protocol',
            name: 'h5-video-clip-slicing-protocol',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/slicing-protocol" */ '@/views/h5/video-clip/slicing-protocol.vue'
              )
          },
          {
            path: 'clip-rank',
            name: 'h5-video-clip-rank',
            component: () =>
              import(/* webpackChunkName: "h5/video-clip/clip-rank" */ '@/views/h5/video-clip/clip-rank.vue'),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'qiepian-must-do',
            name: 'h5-qiepian-must-do',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/qiepian-must-do" */ '@/views/h5/video-clip/qiepian-must-do.vue'
              ),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'member-rights',
            name: 'h5-member-rights',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/member-rights" */ '@/views/h5/video-clip/member-rights.vue'
              ),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'list-of-notice',
            name: 'h5-list-of-notice',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/list-of-notice" */ '@/views/h5/video-clip/list-of-notice.vue'
              ),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'list-of-risk',
            name: 'h5-list-of-risk',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/list-of-risk" */ '@/views/h5/video-clip/risk-of-notice.vue'
              ),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'study-center',
            name: 'h5-study-center',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/study-center" */ '@/views/h5/video-clip/study-center.vue'
              ),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'question',
            name: 'h5-question',
            component: () =>
              import(/* webpackChunkName: "h5/video-clip/question" */ '@/views/h5/video-clip/question.vue'),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'service-complaint',
            name: 'h5-service-complaint',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/service-complaint" */ '@/views/h5/video-clip/service-complaint.vue'
              ),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'agreementUserH5',
            name: 'h5-agreement-user',
            component: () =>
              import(
                /* webpackChunkName: "h5/authorization/components/user-agreement-read" */ '@/views/h5/authorization/components/user-agreement-read.vue'
              ),
            meta: {
              requireLogin: false
            }
          },
          {
            path: 'author-product-list',
            name: 'h5-author-product-list',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/product-list" */ '@/views/h5/video-clip/prodcut-list.vue'
              ),
            meta: {
              requireLogin: true,
              scrollToTop: true
            }
          },
          {
            path: 'order-income',
            name: 'h5-video-clip-order-income',
            component: () =>
              import(
                /* webpackChunkName: "h5/video-clip/order-income" */ '@/views/h5/video-clip/order-income.vue'
              ),
            meta: {
              requireLogin: true,
              scrollToTop: true
            }
          }
        ] |> map(mergeDeepRight({ meta: { requireLogin: true, notShowDialog: true } }))
    }
  ] |> map(mergeDeepRight({ meta: { requireLogin: true, notShowDialog: true } }))

export default pages
